exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block{-ms-flex-negative:0;flex-shrink:0;margin-bottom:40px}@media(min-width: 1160px){.block{width:736px;padding:32px;margin-bottom:32px;border-radius:8px;-webkit-box-shadow:0 4px 24px 0 rgba(51,51,51,.08);box-shadow:0 4px 24px 0 rgba(51,51,51,.08);border:solid 1px #ededed;background-color:#fff}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/block/style.scss
// module id = 1518
// module chunks = 57